import React from 'react';

import { flagStyles } from '../settings';

const SvgKP = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-2856px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgKP;
